import { TemplateConfig } from '../includes/types/Config'
import { AdminTemplateModuleStore } from './StoreTypes'
import actions from './actions'
import mutations from './mutations'

const AdminTemplateModule = {
  namespaced: true,

  state: (): AdminTemplateModuleStore => ({
    accountDataRoot: null,
    loaded: false,
    routes: null,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    applicationConfig: {} as TemplateConfig,
    user: null,
    languageCodes: [],
    isSaveConfigButtonActive: false,
    runtime_config: null,
    globalLoader: false,
    saveButtonCallback: null,
    sidebarMenuReloadToggle: false,
    menuDrawerToggle: false
  }),

  mutations: {
    ...mutations,
  },

  actions: {
    ...actions,
  },

  getters: {
    hasExtraAuth(state: AdminTemplateModuleStore) {
      return state.applicationConfig.profile?.extraAuth ?? false
    },
    userLangOrBrowser(state: AdminTemplateModuleStore) {
      if (state.user && state.user.languageCode) {
        return state.user.languageCode
      }

      return navigator.language.includes('ru-RU') ? 'ru' : 'en'
    }
  },
}

export default AdminTemplateModule
